<template lang="pug">
  div.logoBox(:style="{'backgroundImage': 'url(' + loginBackUrl + ')'}")        
     img.logoTitle(:src='logoTitleUrl')
     div.loginBox(:style="{'backgroundImage': 'url(' + loginBox + ')'}") 
         div.logoInputDiv.firstInputDiv.van-hairline--bottom
             svgIcon(iconStyle='style' iconClass='shouji')
             input.logoInput(v-model='mobileNo' placeholder='请输入手机号' @focus='handleShowDesc(false)' @blur='handleShowDesc(true)')
         div.captcha.logoInputDiv.van-hairline--bottom(v-if="showCaptcha")
             svgIcon(iconStyle='style style-yzm' iconClass='yzm')
             input.logoInput(v-model='captchaCodeImg' placeholder='请输入验证码' @focus='handleShowDesc(false)' @blur='handleShowDesc(true)')
             img.captchaImg(:src='captchaUrl' @click="updateCaptcha")    
         div.mobileCaptcha.logoInputDiv.van-hairline--bottom
             svgIcon(iconStyle='style style-yzm' iconClass='yzm')
             input.logoInput(v-model='mobileCaptcha' placeholder='短信验证码' @focus='handleShowDesc(false)' @blur='handleShowDesc(true)')
             van-button.btnCaptcha(slot="button" size="small" type="primary" :disabled="mobileNo==='' || (captchaCodeImg === '' && showCaptcha)  || disabled" @click="sendSmsCaptcha") {{btnContent}}
         div.login(:style="{'backgroundImage': 'url(' + loginBtn + ')'}" :disabled="mobileNo==='' || (captchaCodeImg === '' && showCaptcha) || mobileCaptcha === ''" @click='login')
</template>

<script>
  import { Button, Toast } from 'vant';
  import config from '../config';
  import svgIcon from './common/icon';

  export default {
    components: {
      'svgIcon':svgIcon,
      [Button.name]: Button,
      [Toast.name]: Toast
    },
    name: 'login',
    created() {
      //token登录
      if(this.$route.query.token){
        this.$store.commit('saveToken',this.$route.query.token);
      }
      this.showCaptcha = config.captcha;
    },
    mounted() {
      //加载验证码
      this.updateCaptcha();
    },
    data() {
      return {
        logoTitleUrl: require('../assets/img/logo_title.png'),
        loginBox: require('../assets/img/login_box.png'),
        loginBackUrl: require('../assets/img/login_back.png'),
        loginBtn: require('../assets/img/login_btn.png'),
        captchaUrl:'',
        mobileNo:'',
        mobileCaptcha:'',
        captchaUidImg:'',
        captchaCodeImg:'',
        captchaUid:'',
        countdown: 60,
        btnContent: '发送验证码',
        disabled: false,
        showCaptcha: false,
        showDesc: true
      };
    },
    methods:{
      login(){
        this.$http.post('/login', {
          captchaUid: this.captchaUid,
          mobileNo: this.mobileNo,
          mobileCaptcha: this.mobileCaptcha
        }).then((response) => {
            if (response.data.success) {
                this.$store.commit('saveToken', response.data.content);
                this.$router.push('/');
            }else{
              Toast(response.data.errorMessage);
            }
        });
      },
      updateCaptcha(){
        this.captchaCodeImg = '';
        this.captchaUidImg = this.$util.guid();
        this.captchaUrl = config.apiUrl+'captcha/getImg?width=80&high=30&captchaUid='+this.captchaUidImg;
      },
      sendSmsCaptcha(){
        this.captchaUid = this.$util.guid();
        this.$http.post('/captcha/sendSms', {
          captchaUidImg: this.captchaUidImg,
          captchaCodeImg: this.captchaCodeImg,
          captchaUid: this.captchaUid,
          mobileNo: this.mobileNo
        }).then((response) => {
            if (response.data.success) {
                this.setCountdown();
            }else{
              this.updateCaptcha();
              Toast(response.data.errorMessage);
            }
        });
      },
      setCountdown() {
        this.btnContent = this.countdown + 's后重新发送';
        this.disabled = true;
        let clock = window.setInterval(() => {
          this.countdown--;
          this.btnContent = this.countdown + 's后重新发送';
          if (this.countdown <= 0) {     //当倒计时小于0时清除定时器
            window.clearInterval(clock)
            this.btnContent = '重新发送验证码';
            this.countdown = 60;
            this.disabled = false;
          }
        },1000);
      },
      handleShowDesc(flag){
        this.showDesc = flag;
      }
    }
  };
</script>

<style lang="less" scoped>
  .logoBox{
    background-color: rgb(236, 240, 241);
    background-repeat:no-repeat;
    background-size: 100% 100%;
    overflow:scroll;
    overflow-y:hidden;
    overflow-x:hidden;
    height: 100%;
    min-height: 667px;
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center; 
    position: relative;
    .logoTitle{
      margin-top: 20px;
      width: 100%;
    }
    .loginBox{
      background-repeat:no-repeat;
      background-size: 100% 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      text-align: center;
      align-items: center; 
      .logoInputDiv{
        position:relative;
        margin: 0 auto 0 auto;
        height: 40px;
        width: 70%;
        border-radius: 6px;
        .btnCaptcha{
          position: absolute;
          top: 5px;
          right: 5px;
          border-radius: 5px;
        }
      }
      .firstInputDiv{
        margin-top: 80px;
      }
      .mobileCaptcha{
        margin-top: 15px;
      }
      .captcha{
        margin-top: 10px;
        border-radius: 3px;
        position: relative;
        .captchaImg{
          border-radius:5px;
          position: absolute;
          right: 5px;
          top: 3px;
          width: 80px;
          height: 30px;
          cursor: pointer;
        }
      }
      .logoInput{
        margin: 5px 0;
        outline: none;
        border: none;
        height: 30px;
        line-height: 30px;
        width: calc(70vw - 60px);
        font-weight: 400;
        font-style: normal;
        font-size: 14px;
        background-color: white;
      }
      .logoInput::-webkit-input-placeholder{
        color: #cccbd2;
      }
      .login{
        background-repeat:no-repeat;
        background-size: auto 100%;
        height: 42px;
        width: 200px;
        margin: 20px 0 30px 0;
      }
    }
    .style{
      position:absolute;
      top:12px;
      left:7px;
      color: rgb(136, 176, 237);
      width: 1em; height: 1em;
      vertical-align: -0.15em;
      fill: currentColor;
      overflow: hidden;
      font-size: 18px;
    }
    .style-yzm{
      top:13px;
      font-size: 16px;
    }
  }
</style>
